import { render, staticRenderFns } from "./EducationsForm.vue?vue&type=template&id=fd481e8e&scoped=true&"
import script from "./EducationsForm.vue?vue&type=script&lang=js&"
export * from "./EducationsForm.vue?vue&type=script&lang=js&"
import style0 from "./EducationsForm.vue?vue&type=style&index=0&id=fd481e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd481e8e",
  null
  
)

export default component.exports